import { render, staticRenderFns } from "./Invitations.vue?vue&type=template&id=f15a9aca&"
import script from "./Invitations.vue?vue&type=script&lang=js&"
export * from "./Invitations.vue?vue&type=script&lang=js&"
import style0 from "./Invitations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports